const userList = () => import('@/pages/UserSet/UserList.vue');
const roleList = () => import('@/pages/RoleSet/RoleList.vue');

export default {
  name: 'userManagement',
  meta: {
    key: 'userManagement',
    hint: 'userManagementHitn'
  },
  path: '/users-management',
  children: [
    {
      name: 'userSet',
      icon: 'ic_common_user',
      path: '/user-management/user-set',
      meta: {
        permission: ['member']
      },
      component: userList
    },
    {
      name: 'roleSet',
      icon: 'ic_common_other_setting',
      path: '/users-management/role-set',
      meta: {
        permission: ['role']
      },
      component: roleList
    }
  ]
};
